/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryMoveEntryResponse } from './RevisdomAPIViewModelsEntryMoveEntryResponse';
import {
    RevisdomAPIViewModelsEntryMoveEntryResponseFromJSON,
    RevisdomAPIViewModelsEntryMoveEntryResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryMoveEntryResponseToJSON,
    RevisdomAPIViewModelsEntryMoveEntryResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryMoveEntryResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1MoveEntryResponse
 */
export interface ApiResponse1MoveEntryResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1MoveEntryResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1MoveEntryResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsEntryMoveEntryResponse}
     * @memberof ApiResponse1MoveEntryResponse
     */
    data?: RevisdomAPIViewModelsEntryMoveEntryResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1MoveEntryResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1MoveEntryResponse interface.
 */
export function instanceOfApiResponse1MoveEntryResponse(value: object): value is ApiResponse1MoveEntryResponse {
    return true;
}

export function ApiResponse1MoveEntryResponseFromJSON(json: any): ApiResponse1MoveEntryResponse {
    return ApiResponse1MoveEntryResponseFromJSONTyped(json, false);
}

export function ApiResponse1MoveEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1MoveEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsEntryMoveEntryResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1MoveEntryResponseToJSON(json: any): ApiResponse1MoveEntryResponse {
    return ApiResponse1MoveEntryResponseToJSONTyped(json, false);
}

export function ApiResponse1MoveEntryResponseToJSONTyped(value?: ApiResponse1MoveEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsEntryMoveEntryResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

